export default __webpack_public_path__ + "static/media/2.b254f764.jpg";